import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './pages/App';
import reportWebVitals from './reportWebVitals';
import { printBootBanner, installDebugConsoleHelpers } from './helpers/apiDebug';

// Dipasang sedini mungkin: banner ini menjadi bukti build MANA yang sedang
// dijalankan browser, dan speakDebug.* bisa dipakai tanpa build ulang.
installDebugConsoleHelpers();
printBootBanner();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
